import { Alert, Button, List, ListItem, ListItemText, Stack, Typography } from '@mui/material';
import type { ConnectedAccounts, MFAStatus } from 'api-client';

export function TwoFactorStatusPanel({ status }: { status: MFAStatus }) {
  return (
    <Stack spacing={2}>
      {status.emailMessage && <Alert severity="info">{status.emailMessage}</Alert>}
      <Alert severity={status.has2faEnabled ? 'success' : status.hasVerifiedEmail ? 'info' : 'warning'}>
        {status.has2faEnabled
          ? 'Two-factor authentication is enabled.'
          : status.hasVerifiedEmail
            ? 'Two-factor authentication is not enabled.'
            : 'Verify your email address before setting up two-factor authentication.'}
      </Alert>
      <Button
        component="a"
        href={status.has2faEnabled || status.hasVerifiedEmail ? status.manageUrl : status.emailUrl}
        variant="outlined"
        sx={{ alignSelf: 'flex-start' }}
      >
        {status.has2faEnabled
          ? 'Manage Two-Factor Authentication'
          : status.hasVerifiedEmail
            ? 'Set Up Two-Factor Authentication'
            : 'Verify Email'}
      </Button>
      <Typography variant="body2" color="text.secondary">
        Secure setup, recovery codes and removal continue on the account security page.
      </Typography>
    </Stack>
  );
}
export function ConnectedAccountsPanel({ data }: { data: ConnectedAccounts }) {
  return (
    <Stack spacing={2}>
      {data.socialAccounts.length === 0 ? (
        <Typography color="text.secondary">You have no connected social accounts.</Typography>
      ) : (
        <List disablePadding>
          {data.socialAccounts.map((account) => (
            <ListItem key={account.id} disableGutters>
              <ListItemText
                primary={`${account.provider}: ${account.email || account.login || account.screenName || account.name || account.uid}`}
                secondary={`Connected ${account.dateJoined.toLocaleDateString()}`}
                sx={{ overflowWrap: 'anywhere' }}
              />
            </ListItem>
          ))}
        </List>
      )}
      <Stack direction="row" useFlexGap flexWrap="wrap" gap={1}>
        <Button component="a" href={data.manageUrl} variant="outlined">
          Manage Accounts
        </Button>
        {!data.hasUsablePassword && (
          <Button component="a" href={data.setPasswordUrl} variant="outlined">
            Add a Password
          </Button>
        )}
      </Stack>
    </Stack>
  );
}
